export function getRecentSearchPublisher(): string[] {
  return JSON.parse(sessionStorage.getItem("publisherList")) || [];
}

export function getPublisherFromPathname() {
  const regex = /.*\/admin\/([^/]+)\/domain.*/;
  const match = window.location.pathname.match(regex);
  return match?.length > 1 ? match[1] : null;
}

export function setRecentSearchPublisher(publisher: string) {
  if (!publisher) {
    sessionStorage.setItem("publisherList", JSON.stringify([]));
    return;
  }
  const publisherList = getRecentSearchPublisher() || [];
  const hasDuplicate = publisherList?.includes(publisher);
  const publisherIndex = publisherList?.indexOf(publisher);

  if (publisherList?.length > 2 && !hasDuplicate) publisherList?.pop();
  else if (hasDuplicate && publisherIndex >= 0)
    publisherList?.splice(publisherIndex, 1);

  publisherList?.unshift(publisher);

  sessionStorage.setItem("publisherList", JSON.stringify(publisherList));
}
